import { useIntl } from 'react-intl';
import { getSupportedLocale } from '../../configuration/lang/lang';
import { useUserProfile } from '../../configuration/login/loginSlice';
import messagesDE from '../translations/de-DE.json';
import messagesEN from '../translations/en-GB.json';

type MessageName =
    | 'intro'
    | 'communication.title'
    | 'communication.description'
    | 'orders.title'
    | 'orders.description'
    | 'compact.intro'
    | 'compact.booking'
    | 'cta';

export const useDriverChatMessages = () => {
    const intl = useIntl();
    const userProfile = useUserProfile();
    const preferredLocale = userProfile?.locale ?? intl.locale;
    const isGerman = preferredLocale.toLowerCase().split(/[-_]/)[0] === 'de';
    const linkLanguage = isGerman ? 'de' : getSupportedLocale(intl.locale).split('-')[0];
    const messages = isGerman ? messagesDE : intl.messages;
    const message = (name: MessageName) => {
        const id = `intl-msg:chat.driverChatUpsell.${name}` as const;
        const translation = messages[id];
        const hasTranslation = typeof translation === 'string' && translation.trim();
        return (
            <span lang={hasTranslation ? (isGerman ? 'de' : intl.locale) : 'en'}>
                {hasTranslation ? translation : messagesEN[id]}
            </span>
        );
    };

    return { message, linkLanguage };
};
